import {ALL_ROOMS, isAllRooms, RoomsFilter} from "./rcn_rooms_filter";

export const PRICES_ADDRESS_ROOMS = [1, 2, 3, 4, 5] as const;

export type PricesAddressRooms = (typeof PRICES_ADDRESS_ROOMS)[number];

export const PRICES_ADDRESS_DEFAULT_ROOMS: PricesAddressRooms = 2;

const getRoomsDistance = (rooms: number): number => Math.abs(rooms - PRICES_ADDRESS_DEFAULT_ROOMS);

export const getDefaultRooms = (availableRooms: number[]): number => {
    if (availableRooms.length === 0) {
        return PRICES_ADDRESS_DEFAULT_ROOMS;
    }

    return availableRooms.reduce((closest, rooms) => {
        const distance = getRoomsDistance(rooms);
        const closestDistance = getRoomsDistance(closest);

        return distance < closestDistance || (distance === closestDistance && rooms < closest) ? rooms : closest;
    });
};

// The aggregate wins whenever the registry publishes it: it rests on every sale under the address rather
// than one size's slice, so it is the widest sample the page can open on. Sizes stay as the drill-down.
export const getDefaultRoomsFilter = (availableRooms: readonly RoomsFilter[]): RoomsFilter => {
    if (availableRooms.some(isAllRooms)) {
        return ALL_ROOMS;
    }

    return getDefaultRooms(availableRooms.filter((rooms): rooms is number => !isAllRooms(rooms)));
};

export const getRoomsTabTitle = (rooms: RoomsFilter): string => {
    switch (rooms) {
        case ALL_ROOMS:
            return "Wszystkie";
        case 1:
            return "1 pokój";
        case 2:
        case 3:
        case 4:
            return `${rooms} pokoje`;
        default:
            return `${rooms} pokoi`;
    }
};

// "mieszkania 3-pokojowe" - the plural form used in running text
export const getRoomsFlatsLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "mieszkania";
    }

    return rooms === 1 ? "kawalerki" : `mieszkania ${rooms}-pokojowe`;
};

// "w kawalerkach" / "w mieszkaniach 3-pokojowych"
export const getRoomsFlatsLabelWhere = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "w mieszkaniach";
    }

    return rooms === 1 ? "w kawalerkach" : `w mieszkaniach ${rooms}-pokojowych`;
};

// "dla kawalerek" / "dla mieszkań 3-pokojowych"
export const getRoomsFlatsLabelOf = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "mieszkań";
    }

    return rooms === 1 ? "kawalerek" : `mieszkań ${rooms}-pokojowych`;
};

// "typowa kawalerka" / "typowe mieszkanie 3-pokojowe"
export const getRoomsTypicalFlatLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "typowe mieszkanie";
    }

    return rooms === 1 ? "typowa kawalerka" : `typowe mieszkanie ${rooms}-pokojowe`;
};

// past tense matching the gender of the labels above: feminine "kawalerka", neuter "mieszkanie"
export const getRoomsFlatCostVerb = (rooms: RoomsFilter): string => (rooms === 1 ? "kosztowała" : "kosztowało");
import {ALL_ROOMS, isAllRooms, RoomsFilter} from "./rcn_rooms_filter";

export const PRICES_ADDRESS_ROOMS = [1, 2, 3, 4, 5] as const;

export type PricesAddressRooms = (typeof PRICES_ADDRESS_ROOMS)[number];

export const PRICES_ADDRESS_DEFAULT_ROOMS: PricesAddressRooms = 2;

const getRoomsDistance = (rooms: number): number => Math.abs(rooms - PRICES_ADDRESS_DEFAULT_ROOMS);

export const getDefaultRooms = (availableRooms: number[]): number => {
    if (availableRooms.length === 0) {
        return PRICES_ADDRESS_DEFAULT_ROOMS;
    }

    return availableRooms.reduce((closest, rooms) => {
        const distance = getRoomsDistance(rooms);
        const closestDistance = getRoomsDistance(closest);

        return distance < closestDistance || (distance === closestDistance && rooms < closest) ? rooms : closest;
    });
};

// The aggregate wins whenever the registry publishes it: it rests on every sale under the address rather
// than one size's slice, so it is the widest sample the page can open on. Sizes stay as the drill-down.
export const getDefaultRoomsFilter = (availableRooms: readonly RoomsFilter[]): RoomsFilter => {
    if (availableRooms.some(isAllRooms)) {
        return ALL_ROOMS;
    }

    return getDefaultRooms(availableRooms.filter((rooms): rooms is number => !isAllRooms(rooms)));
};

export const getRoomsTabTitle = (rooms: RoomsFilter): string => {
    switch (rooms) {
        case ALL_ROOMS:
            return "Wszystkie";
        case 1:
            return "1 pokój";
        case 2:
        case 3:
        case 4:
            return `${rooms} pokoje`;
        default:
            return `${rooms} pokoi`;
    }
};

// "mieszkania 3-pokojowe" - the plural form used in running text
export const getRoomsFlatsLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "mieszkania";
    }

    return rooms === 1 ? "kawalerki" : `mieszkania ${rooms}-pokojowe`;
};

// "w kawalerkach" / "w mieszkaniach 3-pokojowych"
export const getRoomsFlatsLabelWhere = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "w mieszkaniach";
    }

    return rooms === 1 ? "w kawalerkach" : `w mieszkaniach ${rooms}-pokojowych`;
};

// "dla kawalerek" / "dla mieszkań 3-pokojowych"
export const getRoomsFlatsLabelOf = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "mieszkań";
    }

    return rooms === 1 ? "kawalerek" : `mieszkań ${rooms}-pokojowych`;
};

// "typowa kawalerka" / "typowe mieszkanie 3-pokojowe"
export const getRoomsTypicalFlatLabel = (rooms: RoomsFilter): string => {
    if (isAllRooms(rooms)) {
        return "typowe mieszkanie";
    }

    return rooms === 1 ? "typowa kawalerka" : `typowe mieszkanie ${rooms}-pokojowe`;
};

// past tense matching the gender of the labels above: feminine "kawalerka", neuter "mieszkanie"
export const getRoomsFlatCostVerb = (rooms: RoomsFilter): string => (rooms === 1 ? "kosztowała" : "kosztowało");
